import { Injectable } from '@angular/core';

import {
  Auth,
  RecaptchaVerifier,
  signInWithPhoneNumber,
  ConfirmationResult
} from '@angular/fire/auth';

@Injectable({
  providedIn: 'root'
})

export class AuthService {

  confirmationResult!: ConfirmationResult;

  recaptchaVerifier!: RecaptchaVerifier;

  constructor(private auth: Auth) {}

  async sendOTP(phone: string) {

    try {

      if (!this.recaptchaVerifier) {

        this.recaptchaVerifier =
          new RecaptchaVerifier(
            this.auth,
            'recaptcha-container',
            {
              size: 'invisible'
            }
          );

        await this.recaptchaVerifier.render();
      }

      this.confirmationResult =
        await signInWithPhoneNumber(
          this.auth,
          phone,
          this.recaptchaVerifier
        );

      return true;

    } catch (error) {

      console.error(error);

      throw error;
    }
  }

  async verifyOTP(code: string) {

    try {

      return await this.confirmationResult.confirm(code);

    } catch (error) {

      console.error(error);

      throw error;
    }
  }
}